export class Officer {
    ID:number;
CLIENT_ID:number;
NAME:string;
POST:string;
DEPARTMENT:string;
MOBILE_NUMBER:string;
IMAGE_URL:string;
SEQUENCE_NO:number;
STATUS:boolean;

}